import { Text } from '@janeapp/burrito-design-system';
import { ChevronRight } from '@janeapp/burrito-design-system/icons';
import { PractitionerOpening } from '~/api';
import {
  formatRelativeOpeningDate,
  formatFullOpeningDate,
  formatOpeningTime,
} from '~/utilities';

interface OpeningProps {
  opening: PractitionerOpening;
  onBookingClick: () => void;
}

export const Opening = ({ opening, onBookingClick }: OpeningProps) => {
  const startDate = new Date(opening.start);
  const relativeDate = formatRelativeOpeningDate(startDate);
  const time = formatOpeningTime(startDate);
  const fullDate = formatFullOpeningDate(startDate);

  return (
    <button
      className="w-full rounded-md border border-neutral-30 bg-neutral-10 p-3 transition-colors duration-200 hover:bg-neutral-20 focus:bg-neutral-20 focus:outline-none focus:ring-2 focus:ring-brand-60"
      onClick={onBookingClick}
      aria-label={`Book appointment on ${fullDate} at ${time}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex flex-col text-left">
          <Text size="sm" className="mb-1 font-bold text-neutral-90">
            {relativeDate} at {time}
          </Text>
          <Text size="sm" className="text-neutral-60">
            {fullDate}
          </Text>
        </div>
        <div className="ml-3 flex-shrink-0 text-neutral-60">
          <ChevronRight />
        </div>
      </div>
    </button>
  );
};
